module.exports = {
      id: "premium-usage",
      viewBox: "0 0 576 512",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#premium",
      toString: function () {
        return this.url;
      }
    }